import React from 'react';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const GhostButton = ({ children, className, ...props }) => {
    return (
        <button
            className={twMerge(clsx(
                "bg-transparent border border-stone-600 text-white hover:bg-stone-800 px-4 py-2 rounded text-sm font-medium transition-colors flex items-center gap-2",
                className
            ))}
            {...props}
        >
            {children}
        </button>
    );
};
